




















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { UserCredentialsModel } from 'core-types';
import { CoreInputValidators } from 'core-input-validators';
import './CoreLoginPanel.scss';

@Component
export default class Login extends Vue {
  @Prop() appName!: string;

  // SSO
  @Prop() ssoLoginButtonText!: string;

  @Prop({ default: () => '$coreLoginPanelIconQuestion' }) ssoToolTipIcon!: string;

  @Prop() ssoToolTipText!: string;

  @Prop({ default: () => true }) ssoLoginFiledVisible!: boolean;

  // Local
  @Prop({ default: () => '$coreLoginPanelIconPerson' }) localLoginUsernameIcon!: string;

  @Prop({ default: () => '$coreLoginPanelIconLock' }) localLoginPasswordIcon!: string;

  @Prop() localLoginUsernameText!: string;

  @Prop() localLoginPasswordText!: string;

  @Prop({ default: () => '$coreLoginPanelIconEye' }) localLoginPasswordShowIconOn!: string;

  @Prop({ default: () => '$coreLoginPanelIconEyeSlash' }) localLoginPasswordShowIconOff!: string;

  @Prop() localLoginSubmitButtonText!: string;

  @Prop({ default: () => true }) localLoginFieldVisible!: boolean;

  // Go back filed
  @Prop() backToHomeText!: string;

  @Prop({ default: () => '$coreLoginPanelIconArrowLeft' }) backToHomeIcon!: string;

  @Prop({ default: () => false }) backToHomeFieldVisible!: boolean;

  // Mics
  @Prop({ default: () => '' }) error!: string;
  @Prop({ default: () => false }) loading!: boolean;

  // Component data
  private isValid = true;

  private isSubmittedLoginLocal = false;

  private showPassword = false;

  // Getter
  get usernameText(): string {
    return this.localLoginUsernameText || (this.$t('coreLoginPanel.local.loginText') as string);
  }

  get passwordText(): string {
    return this.localLoginPasswordText || (this.$t('coreLoginPanel.local.passwordText') as string);
  }

  // Form
  private usernameRules = [
    (v: any) => CoreInputValidators.required(v),
    (v: any) => CoreInputValidators.minRule(v, 4, true),
    (v: any) => CoreInputValidators.maxRule(v, 10, true)
  ];

  private passwordRules = [
    (v: any) => CoreInputValidators.required(v),
    (v: any) => CoreInputValidators.minRule(v, 8, true),
    (v: any) => CoreInputValidators.maxRule(v, 255, true)
  ];

  // Form data
  private userCredentials: UserCredentialsModel = { username: '', password: '' };

  private validateForm(): void {
    if (this.isValid) {
      this.$emit('localLogin', this.userCredentials);
    }
  }

  get computedAppName(): string {
    return this.appName || process.env.VUE_APP_NAME || '';
  }

  get appVersion(): string {
    // Causes too many errors
    // if (process) {
    //   const version = process.env.VUE_APP_VERSION || undefined;
    //
    //   if (version) {
    //     return version;
    //   }
    // }

    return '';
  }
}
